export default "<img class=\"k-card-image\" ng-src=\"{{$ctrl.image}}\" ng-if=\"$ctrl.image\" />\n<div class=\"k-card-body\" ng-transclude></div>"